module.exports = __webpack_public_path__ + "img/beefTacos.3c478ee4.png";